<template>
  <v-expansion-panel>
    <v-expansion-panel-header class="grey lighten-2">
      <span style="font-weight:bold;">{{ $t('Portable Oxygen Concentrator') }}</span>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <v-card>
        <v-card-text>
          <supply-table-concentrator />
          <plant-slider v-model="hours_concentrator_supply_only" />
          <leakage v-model="leakage_concentrator_supply_only" />
        </v-card-text>
      </v-card>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
import PlantSlider from '@/components/PlantSlider.vue'
import Leakage from '@/components/Leakage.vue'
import SupplyTableConcentrator from '@/components/SupplyTableEditableConcentrator.vue'

export default {
  name: 'Concentrator',

  components: {
    SupplyTableConcentrator,
    PlantSlider,
    Leakage,
  },

  data: () => ({ }),

  computed: {
    ...mapFields([
      'hours_concentrator_supply_only',
      'leakage_concentrator_supply_only',
    ]),
  }
}
</script>
